var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "git-branch-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.575 7.81434C15.575 8.90093 14.6941 9.78178 13.6076 9.78178C12.521 9.78178 11.6401 8.90093 11.6401 7.81434C11.6401 6.72775 12.521 5.8469 13.6076 5.8469C14.6941 5.8469 15.575 6.72775 15.575 7.81434Z",
    fill: "#825DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.575 15.6841C15.575 16.7707 14.6941 17.6515 13.6076 17.6515C12.521 17.6515 11.6401 16.7707 11.6401 15.6841C11.6401 14.5975 12.521 13.7167 13.6076 13.7167C14.6941 13.7167 15.575 14.5975 15.575 15.6841Z",
    fill: "#825DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6401 15.6841C11.6401 16.7707 12.521 17.6515 13.6076 17.6515C14.6941 17.6515 15.575 16.7707 15.575 15.6841C15.575 14.5975 14.6941 13.7167 13.6076 13.7167C12.521 13.7167 11.6401 14.5975 11.6401 15.6841ZM11.6401 15.6841H9.00039C6.79133 15.6841 5.00049 13.8934 5.00039 11.6843L5 3.83334M11.2712 7.81434H5M15.575 7.81434C15.575 8.90093 14.6941 9.78178 13.6076 9.78178C12.521 9.78178 11.6401 8.90093 11.6401 7.81434C11.6401 6.72775 12.521 5.8469 13.6076 5.8469C14.6941 5.8469 15.575 6.72775 15.575 7.81434Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryActive);
export default __webpack_public_path__ + "static/media/category-active.b35479b98b4e1cb6294a448c9d450cbe.svg";
export { ForwardRef as ReactComponent };